import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router";

import { ApplicationError, ThemedLoader, setPageTitle } from "Application";
import { MentorsViewModel } from "./MentorsViewModel";

import { Tabs } from "Components/Tabs/Tabs";
import { CurrentMentorsView } from "../Views/CurrentMentors/CurrentMentorsView";
import { PastMentorsView } from "../Views/PastMentors/PastMentorsView";
import styled from "@emotion/styled";

interface ActiveViewProps {
    viewModel: MentorsViewModel;
}

const ActiveView: React.FC<ActiveViewProps> = observer(({ viewModel }) => {
    if (viewModel.apiClient.IsBusy) {
        return <ThemedLoader isOpen delayBeforeOpen={1000} containerStyles={{ height: "calc(100vh - 160px)", width: "calc(100vw - 80px)" }} />;
    }

    if (viewModel.apiClient.IsSubmitted && viewModel.apiClient.HaveValidationMessage) {
        return (
            <div className="error-scrollable-section">
                <div>
                    <ApplicationError additionalMessage={viewModel.apiClient.ValidationMessage} resetCommand={viewModel.resetApiClientErrorCommand} />
                </div>
            </div>
        );
    }

    switch (true) {
        case viewModel.showCurrent:
            return <CurrentMentorsView onConfirmMentorStatusChangeCommand={viewModel.onConfirmMentorStatusChangeCommand} />;
        case viewModel.showPast:
            return <PastMentorsView />;
        default:
            return <CurrentMentorsView onConfirmMentorStatusChangeCommand={viewModel.onConfirmMentorStatusChangeCommand} />;
    }
});

const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    margin-top: 35px;
`;

export const MentorsView: React.FC = observer(() => {
    const location = useLocation();
    const [viewModel] = useState(() => new MentorsViewModel());

    useEffect(() => {
        setPageTitle("Mentors");
        viewModel.getMentorCountAsync();
    }, []);

    useEffect(() => {
        viewModel.setPathname(location.pathname);
    }, [location.pathname]);

    return (
        <>
            <Container>
                <Tabs tabs={viewModel.tabs} />
                <ActiveView viewModel={viewModel} />
            </Container>
        </>
    );
});
